import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdatePrestacionModalidadCiclicaByID = () => {
  const [loadingUpdatePrestacionModalidadCiclicaById, setLoadingCreatePrestacionModalidadCiclica] = useState(false);
  const [successUpdatePrestacionModalidadCiclicaById, setSuccessCreatePrestacionModalidadCiclica] = useState(false);
  const [errorUpdatePrestacionModalidadCiclicaById, setErrorCreatePrestacionModalidadCiclica] = useState(null);
  const [dataUpdatePrestacionModalidadCiclicaById, setDataPrestacionModalidadCiclica] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updatePrestacionModalidadCiclicaById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionModalidadCiclica(true);
    setSuccessCreatePrestacionModalidadCiclica(false);
    setErrorCreatePrestacionModalidadCiclica(null);

  
    apiRecord.updateSolicitudModalidadCiclicaByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionModalidadCiclica(false);
        setSuccessCreatePrestacionModalidadCiclica(true);
        setDataPrestacionModalidadCiclica(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionModalidadCiclica(false);
        setErrorCreatePrestacionModalidadCiclica(err.response?.data);
      });
  };

  return {
    updatePrestacionModalidadCiclicaById,
    loadingUpdatePrestacionModalidadCiclicaById,
    successUpdatePrestacionModalidadCiclicaById,
    errorUpdatePrestacionModalidadCiclicaById,
    dataUpdatePrestacionModalidadCiclicaById
  };
};

export default useUpdatePrestacionModalidadCiclicaByID;
